export const selectLearningTasks = (state) => {
    return state.learningTasks.models;
};
export const selectLearningTask = (id) => (state) => {
    return state.learningTasks.models.filter((lt) => lt.id === id)[0];
};
export const selectAnswerLastSavedAt = (state) => {
    return state.learningTasks.answerLastSavedAt;
};
export const selectAreLearningTasksLoading = (state) => {
    if (!state.learningTasks)
        return true;
    return state.learningTasks.isLoading;
};
